/**
 * @flow
 */
import React, { Component } from 'react'
import YouTube from 'react-youtube'
import Lightbox from '../../Lightbox'
import CloseModalIcon from '../../Icons/CloseModalIcon'
import {
  CloseIconWrapper,
  VideoContainer,
  YoutubeWrapper
} from './styledComponents.js'
import './index.scss'

class VideoComponentModal extends Component {
  render() {
    const { isOpen, close, videoId } = this.props
    const gsvidopts = {
      playerVars: {
        autoplay: 1
      }
    }
    return (
      <div>
        <Lightbox isOpen={isOpen} onClose={close}>
          <VideoContainer>
            <CloseIconWrapper onClick={close}>
              <CloseModalIcon />
            </CloseIconWrapper>
            <YoutubeWrapper>
              <YouTube
                className="YouTube-overview-Classnm"
                videoId={videoId}
                onReady={this.onReady}
                opts={gsvidopts}
              />
            </YoutubeWrapper>
          </VideoContainer>
        </Lightbox>
      </div>
    )
  }
}

export default VideoComponentModal



// WEBPACK FOOTER //
// ./src/components/common/VideoComponentModal/index.js